import { Box, Paper, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";

import { useFeatureFlagEnabled } from "../../../common/posthog";
import { AccountConfiguration } from "./configuration/AccountConfiguration";
import { AnalysisEntities } from "./entities/AnalysisEntities";
import { AnalysisProfiles } from "./profiles/AnalysisProfiles";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`account-analysis-tabpanel-${index}`}
      aria-labelledby={`account-analysis-tab-${index}`}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const a11yProps = (index: number) => {
  return {
    id: `account-analysis-tab-${index}`,
    "aria-controls": `account-analysis-tabpanel-${index}`
  };
};

export const AccountAnalysisTabs: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const showConfigurationTab = useFeatureFlagEnabled("analysis-configuration-tab");

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ borderRadius: 2 }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="Account analysis tabs"
            sx={{
              "& .MuiTab-root": {
                textTransform: "uppercase"
              }
            }}
          >
            <Tab label="Analysis Groups" {...a11yProps(0)} />
            <Tab label="People" {...a11yProps(1)} />
            {showConfigurationTab && <Tab label="Analysis Configuration" {...a11yProps(2)} />}
          </Tabs>
        </Box>

        <TabPanel value={activeTab} index={0}>
          <AnalysisProfiles onPeopleTabClick={() => setActiveTab(1)} />
        </TabPanel>

        <TabPanel value={activeTab} index={1}>
          <AnalysisEntities />
        </TabPanel>

        {showConfigurationTab && (
          <TabPanel value={activeTab} index={2}>
            <AccountConfiguration />
          </TabPanel>
        )}
      </Paper>
    </Box>
  );
};
